// Module
var code = "<article-templates></article-templates>\n";
// Exports
module.exports = code;